import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { cn } from '../../lib/helpers.ts';

interface TabItem {
    id: string;
    label: ReactNode | string;
    content: ReactNode | string;
}

type TabVariant = 'default' | 'onboarding';

const tabVariants = {
    default: {
        tabList: "inline-block border border-gray-400 w-auto rounded-2xl p-1 space-x-1",
        tab: [
            'relative rounded-xl px-3.5 py-1.5 font-medium text-xs',
            'data-[selected=false]:transition-colors data-[hover]:bg-cloud-200',
            'data-[selected]:bg-product-700 data-[selected]:text-white',
            'data-[selected]:data-[hover]:bg-product-700 data-[selected]:data-[hover]:text-white'
        ]
    },
    onboarding: {
        tabList: "flex flex-1 flex-col justify-center sm:flex-row gap-4",
        tab: [
            'flex items-center gap-2 rounded-xl border px-2 py-1 transition-colors border-cloud-300 bg-cloud-200 text-base text-ink-800',
            'data-[selected]:border-product-500 data-[selected]:bg-product-500 data-[selected]:text-white',
            // 'data-[selected=false]: data-[selected=false]:bg-cloud-200 data-[selected=false]:',
            'data-[hover]:bg-cloud-300'
        ]
    }
} as const;

export default function Tabs({ tabs, state, heading, variant = 'default' }: { tabs: TabItem[], state: [number, Dispatch<SetStateAction<number>>], heading: ReactNode|string, variant?: TabVariant }) {
    const [selectedIndex, setSelectedIndex] = state;
    const variantConfig = tabVariants[variant];

    return <>
        <TabGroup selectedIndex={selectedIndex} onChange={setSelectedIndex}>
            <div className="flex space-x-3 items-center">
                {heading}

                <TabList className={variantConfig.tabList}>
                    {tabs.map(({ id, label }) => (
                        <Tab key={id} className={cn(variantConfig.tab)}>
                            {label}
                        </Tab>
                    ))}
                </TabList>
            </div>
            <TabPanels className="mt-2">
                {tabs.map(({ id, content }) => (
                    <TabPanel key={id}>{content}</TabPanel>
                ))}
            </TabPanels>
        </TabGroup>
    </>;
}
